<template>
  <div ref="nav" class="header-nav wrap hidden-xs" :class="{ 'sticky': isSticky }">
    <!-- 导航内容 -->
    <ul class="header-nav-wrapper comm-wrap">
      <li
        v-for="(item,index) in navList"
        :key="index"
        :class="index==navIndex?'active':''"
        @click="navClick(item.name, index)"
      >
        <router-link :to="item.path">
          {{item.name}}
          <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down" ></span>
          <i class="underline"></i>
        </router-link>
        <dl v-if="item.children.length>0">
          <dt v-for="(i,n) in item.children" :key="n" :class="{active: navPath === i.path}" @click.stop="setNavPath(i.path, index)">
            <span class="sub-text">{{ i.name }}</span>
            <!-- <router-link :to="i.path">{{i.name}}</router-link> -->
          </dt>
        </dl>
      </li>
    </ul>
  </div>
</template>
<script>
import { addVisit, articleList, getArticle } from '@/api/hangzhi.js'
import { visitConfig, menuConfig } from '@/assets/static/apiConfig.js'

export default {
  name: "Nav",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      navPath: '',
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/home",
          children: []
        },
        // {
        //   name: "良渚创新平台",
        //   path: "/innovationPlatform/lifeScience",
        //   children: [
        //     {
        //       name: "良渚生命科学平台",
        //       path: "/innovationPlatform/lifeScience"
        //     }, {
        //       name: "良渚数字文化创意平台",
        //       path: "/innovationPlatform/digitalCulturalCreative"
        //     }, {
        //       name: "良渚工业设计平台",
        //       path: "/innovationPlatform/industrialDesign"
        //     }
        //   ]
        // },
        {
          name: "办事大厅",
          path: "/officeHall/hallIntroduction",
          children: []
        },
        {
          name: "数据中心",
          path: "/idc",
          children: []
        },
        {
          name: "出海服务",
          path: "/seaService",
          children: []
        },
        {
          name: "知识产权交易",
          path: "/propertyFair",
          children: []
        },
        {
          name: "品牌指导",
          path: "/brandGuidance",
          children: []
        },
        {
          name: "政策资讯",
          path: "/policyInformation",
          children: []
        }
      ],
      // 吸顶
      isSticky: false,
      offsetTop: 0
    };
  },
  mounted() {
    this.syncNavByRoute(this.$route);
    this.$nextTick( () => {
      this.offsetTop = this.$refs.nav.offsetTop;
    })
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    '$route'(to) {
      this.syncNavByRoute(to);
    }
  },
  methods: {
    syncNavByRoute(route) {
      const path = route.path;
      this.navPath = path;
      let matchedIndex = -1;
      this.navList.forEach((item, index) => {
        if (path === item.path || path.startsWith(item.path + '/')) {
          matchedIndex = index;
        }
      });
      // 首页特殊处理（/ 重定向到 /home）
      if (path === '/' || path === '/home') {
        matchedIndex = 0;
      }
      if (matchedIndex !== -1) {
        this.navIndex = matchedIndex;
        sessionStorage.setItem('navIndex', matchedIndex);
      }
    },
    navClick(item, index) {
      if(item == '数据中心'){
        addVisit(visitConfig.dataCenter).then(res => {
        })
      }
      this.navIndex = index;
      this.navPath = item.path
      sessionStorage.setItem('navIndex',index)
      this.menuName = item.name;
    },
    setNavPath(path, index) {
      this.navPath = path;
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.$router.push(path)
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },

    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.isSticky = scrollTop > this.offsetTop ? true : false;
    }
  }
};
</script>
<style scoped>
/* 导航栏 */
.header-nav {
  height: 70px;
  background: #0E4CA2;
  z-index: 1000;
}
/* 导航栏 导航容器 */
.header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
.header-nav .header-nav-wrapper {
  display: flex;
  justify-content: space-between;
  line-height: 70px;
}
/* 导航栏 每个导航 */
.header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
.header-nav .header-nav-wrapper > li > a {
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
  text-decoration: none;
  outline: none;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
.header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -11px;
  left: 50%;
  width: 0;
  height: 4px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #fff;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
.header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
.header-nav .header-nav-wrapper > li > a:hover {
  color: #fff;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
.header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 50px;
  left: 50%;
  transform: translateX(-50%);
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
.header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
.header-nav .header-nav-wrapper > li a:visited {
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
.header-nav .header-nav-wrapper > li.active > a .underline{
  color: #fff;
  text-decoration: none;
  opacity: 1;
  width: 50px;
  left: 50%;
  transform: translateX(-50%);
  border-bottom: 4px solid #fff;
}
/* 导航栏 每个导航下面的二级导航容器 */
.header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  padding-top: 26px;
  padding-bottom: 12px;
  width: 220px;
  height: 160px;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999999;
  /* box-shadow: 0 0 1px 1px #eee; */
  /* background: #fff; */
  border-radius: 6px;
  background: url('../assets/img/back_menu.png') no-repeat center;
  z-index: 1001;
}
/* .header-nav .header-nav-wrapper > li > dl::before {
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  content: "";
  border: 10px solid transparent;
  border-bottom-color: #fff;
  box-shadow: 0 0 1px 1px #eee;
} */
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
.header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.header-nav .header-nav-wrapper > li > dl > dt .sub-text {
  font-size: 16px;
  color: #000;
}
.header-nav .header-nav-wrapper > li > dl > dt.active .sub-text {
  font-size: 16px;
  color: #386ACF;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
.header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
.header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
.header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #efefef;
  /* color: #386ACF; */
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}

.sticky {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0px 4px 10px 0px rgba(39, 39, 39, 0.2);
}
.header-nav.sticky .header-nav-wrapper > li > a {
  color: #2f2f2f;
}
.header-nav.sticky .header-nav-wrapper > li > a > i {
  background: #2f2f2f;
}
.header-nav.sticky .header-nav-wrapper > li > a:hover {
  color: #2f2f2f;
}
.header-nav.sticky .header-nav-wrapper > li.active > a .underline {
  color: #2f2f2f;
  border-bottom-color: #2f2f2f;
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue